export default {"src":"/_next/static/media/drawer-icon.f86d5238.svg","height":12,"width":18,"blurWidth":0,"blurHeight":0};